import { yupResolver } from '@hookform/resolvers/yup';
import { Resolver } from 'react-hook-form';
import * as Yup from 'yup';
import initDefaultSchema from '../yupConfig';
import { CreateBotsLinkT, CreateChannelsLinkT } from 'shared/api/types/links';

initDefaultSchema();

// Create Bot's Link
export type CreateBotsLinkFormT = CreateBotsLinkT['request'];
export const getCreateBotsLinkValues = (): CreateBotsLinkFormT => ({
  source: '',
  buyer: '',
  fbPixel: '',
  fbToken: '',
  botId: ''
});

const createBotsLinkSchema: Yup.ObjectSchema<CreateBotsLinkFormT> = Yup.object({
  botId: Yup.string().required(),
  source: Yup.string(),
  buyer: Yup.string(),
  fbPixel: Yup.string(),
  fbToken: Yup.string()
});

export const createBotsLinkResolver = yupResolver(createBotsLinkSchema) as Resolver<CreateBotsLinkFormT>;

// Create Channel's Link
export type CreateChannelsLinkFormT = CreateChannelsLinkT['request'];
export const getCreateChannelsLinkValues = (): CreateChannelsLinkFormT => ({
  source: '',
  buyer: '',
  fbPixel: '',
  fbToken: '',
  channelId: ''
});

const createChannelsLinkSchema: Yup.ObjectSchema<CreateChannelsLinkFormT> = Yup.object({
  channelId: Yup.string().required(),
  source: Yup.string(),
  buyer: Yup.string(),
  fbPixel: Yup.string(),
  fbToken: Yup.string()
});

export const createChannelsLinkResolver = yupResolver(createChannelsLinkSchema) as Resolver<CreateChannelsLinkFormT>;
